import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useVideo } from '../context/VideoContext';

const DateFilter: React.FC = () => {
  const { selectedDate, setSelectedDate } = useVideo();

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = new Date(e.target.value);
    setSelectedDate(date);
  };

  const formatDate = (date: Date) => {
    return date.toISOString().split('T')[0];
  };

  return (
    <Row className="mb-4">
      <Col md={4}>
        <Form.Group>
          <Form.Label>Выберите дату</Form.Label>
          <Form.Control
            type="date"
            value={formatDate(selectedDate)}
            onChange={handleDateChange}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default DateFilter;